module.exports = __webpack_public_path__ + "img/horizontal_6_4_5012.2af0ab00.png";